@let apiResponse = data();
<div class="flex flex-col h-full">
  <div>
    <h1>Letregister</h1>
  </div>
  <p-tabs
    [(value)]="letregisterService.activeTab"
    class="flex-1 border-1 overflow-hidden"
  >
    <p-tablist>
      <p-tab value="search"><i class="pi pi-search"></i> Søgning</p-tab>
      @if (apiResponse && apiResponse.data.length > 0 &&
      letregisterService.selectedKunde()) {
      <p-tab value="aftaler"><i class="pi pi-list"></i> Aftaler </p-tab>
      } @if (letregisterService.selectedLetsikring()) {
      <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="search">
        <app-letregister-search />
      </p-tabpanel>
      <p-tabpanel value="aftaler">
        <app-letregister-aftaler />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-letregister-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
